'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./box-notification.scss');

var _icon = require('../icon/icon');

var _icon2 = _interopRequireDefault(_icon);

var _title = require('../title/title');

var _title2 = _interopRequireDefault(_title);

var _loader = require('../loader/loader');

var _loader2 = _interopRequireDefault(_loader);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var icons = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  hint: 'information'
};

function BoxNotification(_ref) {
  var className = _ref.className,
      children = _ref.children,
      title = _ref.title,
      type = _ref.type,
      props = _objectWithoutProperties(_ref, ['className', 'children', 'title', 'type']);

  var classes = (0, _classnames2.default)('box-notification', type && 'box-notification--' + type, className);

  if (type === 'loading') {
    return _react2.default.createElement(
      _loader2.default,
      { className: 'box-notification box-notification--loader' },
      title
    );
  }

  return _react2.default.createElement(
    'div',
    _extends({ className: classes }, props),
    _react2.default.createElement(_icon2.default, { name: icons[type], size: '40', className: 'box-notification__icon' }),
    _react2.default.createElement(
      _title2.default,
      {
        level: '3',
        align: 'center',
        color: 'dark',
        className: 'box-notification__title'
      },
      title
    ),
    children
  );
}

BoxNotification.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  title: _propTypes2.default.string,
  type: _propTypes2.default.oneOf(['success', 'error', 'warning', 'hint', 'loading'])
};

exports.default = BoxNotification;